import { CentralizedLogin, Config } from '@foxcorp/foxkit-profile-js/centralized-login';

import { getUiConfig } from '@/config/client/getUiConfig';

import { configOptions } from './configOptions';
import { statefulRefreshToken } from './statefulRefreshToken';

const uiConfig = getUiConfig();

const config = new Config({
  ...configOptions,

  clientId: uiConfig.clientId,
  redirectUri: uiConfig.callbackUrl,
  authBaseUrl: uiConfig.authUrl,
  environment: uiConfig.environmentAlt,

  statefulRefreshToken,
});

console.debug('[CentralizedLogin]', { config, env: uiConfig.environmentAlt, authUrl: uiConfig.authUrl });

export const centralizedLogin = new CentralizedLogin(config);
